import Vue from 'vue'
import KmartButton from './KmartButton/KmartButton.vue'
import KmartHeading from './KmartHeading/KmartHeading.vue'

const Components = {
  KmartButton,
  KmartHeading
}

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name])
})

export default Components
